import AxDialog from '@/components/03-components/dialog/dialog';
import AxIconChip from './components/03-components/icon-chip/icon-chip';
import AxInfoPanel from '@/components/03-components/info-panel/info-panel';
import AxModal from '@/components/03-components/modal/modal';
import AxNavbar from './components/04-web-components/navbar';
import AxPowerbar from './components/04-web-components/powerbar';
import AxScopelessbar from './components/04-web-components/scopelessbar';
import AxSelect from '@/components/02-elements/input/select';
import AxToast from '@/components/03-components/toast/ax-toast';
import AxTooltip from '@/components/03-components/tooltip/tooltip';
import AxSpinner from '@/components/03-components/spinner/spinner';
import AxTable from '@/components/02-elements/tables/ax-tables';
import AxPagination from '@/components/02-elements/pagination/ax-pagination';
import AxDatePicker  from '@/components/03-components/date-picker/date-picker'

interface VueProxyType {
  component(name: string, comp: any): void;
}

const install = function (Vue: VueProxyType) {
  Vue.component('AxNavbar', AxNavbar);
  Vue.component('AxPowerbar', AxPowerbar);
  Vue.component('AxScopelessbar', AxScopelessbar);

  // for direct browser CDN style usage -- inline html vue elements tag are normalized.
  Vue.component('axnavbar', AxNavbar);
  Vue.component('axpowerbar', AxPowerbar);
  Vue.component('axscopelessbar', AxScopelessbar);
};

export {
  AxDialog,
  AxIconChip,
  AxInfoPanel,
  AxModal,
  AxNavbar,
  AxPowerbar,
  AxScopelessbar,
  AxSelect,
  AxTooltip,
  AxToast,
  AxSpinner,
  install,
  AxTable,
  AxPagination,
  AxDatePicker,
};

export default {
  AxDialog,
  AxIconChip,
  AxInfoPanel,
  AxModal,
  AxNavbar,
  AxPowerbar,
  AxScopelessbar,
  AxSelect,
  AxTooltip,
  AxToast,
  AxSpinner,
  install,
  AxTable,
  AxPagination,
  AxDatePicker
};
